module.exports = __webpack_public_path__ + "img/teilnehmer-privatstunde_02.36a134a2.svg";